/**
 * Creates a valid 'application/x-www-form-urlencoded' (URLSearchParams) request body from the given form data.
 *
 * @example
 * const formData = new FormData(document.getElementById('my-form'));
 * const body = asRequestBody(formData);
 * const response = fetch('https://example.com/api', {
 *  method: 'POST',
 *  body,
 * });
 */
export function asRequestBody(formData) {
    const body = new URLSearchParams();
    for (const [key, value] of formData) {
        body.append(key, value.toString());
    }
    return body;
}
